import React from 'react';
import * as S from './top-hotels.styles';
import { BookButton, FlightsRoute } from '../flight-fares/flight-fares.styles';
import RupeeIcon from '../../../../icons/Rupee';
import ToolTipForHotels from '../tool-tip/tool-tip';

const TopHotelBlock = ({ hotelAttraction, type, isDweb = false }) => {
  const { name } = hotelAttraction;
  let booking_price, image, location, reviewText, reviewName, reviewTimestamp, url;
  if (type === 'hotels') {
    booking_price = hotelAttraction.booking_price;
    image = hotelAttraction.image;
    location = hotelAttraction.location;
    reviewText = hotelAttraction.review.rc;
    reviewName = hotelAttraction.review.rn;
    reviewTimestamp = hotelAttraction.review.rts;
    url = hotelAttraction.url;
  } else {
    reviewText = hotelAttraction.desc.short;
    image = hotelAttraction.img;
    url = hotelAttraction.link;
  }

  const bookUrl = type === 'hotels' ? url : `https://goibibo.com${url}`;
  return (
    <S.TopHotelColWrap isDweb={isDweb}>
      <S.TopHotelCol className="flexCol" isHotel={type === 'hotels'}>
        <S.HotelImgBg>
          <S.HotelImg src={image} loading="lazy" />
        </S.HotelImgBg>
        <S.HotelNameRating>
          <S.HotelHead className="go_blue truncate width80 padB5">
            <a href={bookUrl}>{name}</a>
          </S.HotelHead>
          {type === 'hotels' ? <S.HotelSubHead className="grey">{location}</S.HotelSubHead> : null}
          {type === 'hotels' ? (
            <S.HotelRating>
              {[1, 2, 3, 4, 5].map(star => (
                <S.Star key={star} isTrue={star <= (hotelAttraction.star_rating * 5) / 100} />
              ))}
            </S.HotelRating>
          ) : null}
        </S.HotelNameRating>
        <S.HotelReview className="flexCol">
          {type === 'hotels' ? (
            isDweb ? (
              <ToolTipForHotels reviewText={reviewText} hotel={hotelAttraction} />
            ) : (
              <a href={bookUrl}>
                <S.ReviewTxt className="grey lh1-5">{reviewText}</S.ReviewTxt>
              </a>
            )
          ) : (
            <S.ReviewTxt className="grey lh1-5">{reviewText}</S.ReviewTxt>
          )}
          {type === 'hotels' ? (
            <div className="padT5">
              {reviewName}
              <S.ReviewDate className="grey">{` ${reviewTimestamp}`}</S.ReviewDate>
            </div>
          ) : null}
        </S.HotelReview>
        {type === 'hotels' ? (
          <S.HotelPrice className="dF alignItemsCenter justifyEnd">
            <S.Price className="alignItemsCenter dF fb">
              <RupeeIcon fill="#141823" />
              {booking_price} &nbsp; &nbsp;
            </S.Price>
            <a href={bookUrl}>
              <BookButton>
                <S.RouteBook>Book Now</S.RouteBook>
              </BookButton>
            </a>
          </S.HotelPrice>
        ) : null}
      </S.TopHotelCol>
    </S.TopHotelColWrap>
  );
};

const TopHotels = ({ hotelsAttractions, type, headerTitle, viewTitle, link, isDweb = false }) => {
  return (
    <FlightsRoute>
      <S.FlightFareChart>
        <div className="dF justifyBetween padB5">
          <S.RouteHd className="quicksand padB5">{headerTitle}</S.RouteHd>
          <a href={link}>{viewTitle}</a>
        </div>
        <div className="width100 dF padT5 flexWrap">
          {hotelsAttractions &&
            hotelsAttractions.map(hotelAttraction => (
              <TopHotelBlock hotelAttraction={hotelAttraction} type={type} isDweb={isDweb} />
            ))}
        </div>
      </S.FlightFareChart>
    </FlightsRoute>
  );
};

export default TopHotels;
